import { getProjectStatusColor } from '../../../utils/projectStatus'

export interface ProjectTaskStatusOption {
    key: string
    title: string
    color: string
}

export function getProjectTaskStatuses(project: any): ProjectTaskStatusOption[] {
    const statuses = Array.isArray(project?.task_statuses) && project.task_statuses.length
        ? project.task_statuses
        : Array.isArray(project?.statuses)
            ? project.statuses
            : []

    return statuses
        .filter((status: any) => Boolean(status?.key))
        .map((status: any) => ({
            key: status.key,
            title: status.name || status.title || status.key,
            color: getProjectStatusColor(status.key, status.color || '#B1AEC7'),
        }))
}

export function getProjectTaskStatus(project: any, statusKey: string) {
    return getProjectTaskStatuses(project).find((status) => status.key === statusKey)
}
